import device from 'current-device'

export default device